import { render, staticRenderFns } from "./ScreenHomeLaudos.vue?vue&type=template&id=16c4a62e&lang=true&"
import script from "./ScreenHomeLaudos.vue?vue&type=script&lang=js&"
export * from "./ScreenHomeLaudos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports